import { adminExerciseVideoPinSchema, type AdminExerciseVideoPin } from '@steado/admin-contract/exercises';
import { queryOptions } from '@tanstack/react-query';
import { z } from 'zod';

import type { ApiClient } from '@/lib/api/client';

export function exerciseVideoPinQueryOptions(api: ApiClient, exerciseId: string) {
  return queryOptions({
    queryKey: ['admin', 'exercise-video-pin', exerciseId],
    queryFn: (): Promise<AdminExerciseVideoPin | null> =>
      api.request({
        path: `/admin/exercises/${exerciseId}/video-pin`,
        schema: adminExerciseVideoPinSchema.nullable(),
      }),
  });
}

/** `videoId` may be a pasted link; the server takes the id out of it. */
export function pinExerciseVideo(
  api: ApiClient,
  exerciseId: string,
  videoId: string,
): Promise<AdminExerciseVideoPin> {
  return api.request({
    path: `/admin/exercises/${exerciseId}/video-pin`,
    method: 'PUT',
    body: { videoId },
    schema: adminExerciseVideoPinSchema,
  });
}

export function unpinExerciseVideo(api: ApiClient, exerciseId: string): Promise<null> {
  return api.request({
    path: `/admin/exercises/${exerciseId}/video-pin`,
    method: 'DELETE',
    schema: z.null(),
  });
}
